import {
  MicrocopyFragment,
  RichMicrocopyFragment,
} from '@graphql/generated-contentful/graphql';
import { MicrocopyItem } from '@lib/types/cms/MicrocopySet';
import { isDefined } from './isDefined';

export type Microcopy = {
  key: string;
  value: string;
};

export enum MicrocopySlug {
  USER_PROFILE = 'user-profile',
  HEADER = 'header',
  LAYOUT = 'layout',
  SEARCH = 'search',
  SEARCH_VALUES = 'search-ui-values',
  PRODUCT_CARD = 'product-card',
  PAGINATION = 'pagination',
  PRODUCT_DETAILS_PAGE = 'pdp',
  CATEGORIES = 'categories',
  LIVESTREAM = 'livestream',
  MY_ASSETS_PAGE = 'my-assets',
  PUBLISHER_PROFILE = 'publisher-profile',
}

export const getMicrocopySet = (
  namespace: MicrocopySlug,
  collection: MicrocopyItem[]
) => {
  return (key: string) =>
    collection?.find((microcopy) => microcopy.key === `${namespace}.${key}`)
      ?.value;
};

export const formatMicrocopy = (
  microcopy: MicrocopyItem[]
): Record<string, string> => {
  const formattedMicrocopy: Record<string, string> = {};
  const definedMicrocopy = microcopy.filter(
    (item): item is MicrocopyItem =>
      isDefined<MicrocopyItem>(item) &&
      isDefined(item.value) &&
      isDefined(item.key)
  );

  definedMicrocopy.forEach((microcopyItem) => {
    formattedMicrocopy[microcopyItem.key!] = microcopyItem.value!;
  });

  return formattedMicrocopy;
};

export function isContentfulRichMicrocopy(
  microcopy: MicrocopyFragment | RichMicrocopyFragment
): microcopy is RichMicrocopyFragment {
  return (microcopy as RichMicrocopyFragment).richValue !== undefined;
}
